jQuery(document).ready(function () {
  

  $(document).on("change", ".btnbox-product .quantity__input", function () {
    var value = $(this).val(),
      price = $(this).attr("data-price"),
      totalPrice = parseInt(price) * parseInt(value);

    var formatString = "{{amount}} " + window.storeCurrency;

    console.log(value + " - " + " - " + price + "  " + totalPrice);
    $(document)
      .find(".price-custom-change")
      .text(formatMoney(totalPrice, window.shopMoneyFormat));
  });

  $(document).ready(function () {
    $(".mega-menu__list > li:lt(3) > a").removeAttr("href");
  });

  if (window.innerWidth < 992) {
    var $button = $(".headermenu-btn");

    // Check if not already moved
    if (!$button.closest("li").parent().hasClass("menu-drawer__navigation")) {
      // Wrap in <li> and append
      var $li = $("<li class='headerbtnli'></li>").append($button);
      $(".menu-drawer__navigation ul").append($li);
    }
  }

  const swiper = new Swiper(".recommandproduct-slider", {
    slidesPerView: 1,
    spaceBetween: 0,
    loop: true,
    autoplay: {
      delay: 5000,
    },
    navigation: {
      nextEl: ".recommandproduct-slider-Next",
      prevEl: ".recommandproduct-slider-Prev",
    },
    pagination: {
      el: ".recommandproduct-pagination",
      clickable: true,
    },
  });

  const productavis = new Swiper(".product-avis-slider", {
    slidesPerView: 1,
    spaceBetween: 0,
    loop: true,
    autoplay: {
      delay: 4000,
    },
    pagination: {
      el: ".product-avis-pagination",
      clickable: true,
    },
  });

  // const blogcat = new Swiper('.blog-categories-slider', {
  //      slidesPerView: 'auto',
  //       spaceBetween: 30,
  //       loop: true,
  //       // autoplay: {
  //       //     delay: 4000,
  //       // },
  //    navigation: {
  //           nextEl: ".blogcat-slider-Next",
  //           prevEl: ".blogcat-slider-Prev",
  //       },

  //   });

  const accompagnement = new Swiper(".accompagnement-slider", {
    slidesPerView: 1,
    spaceBetween: 0,
    loop: true,
    autoplay: {
      delay: 5000,
    },
    navigation: {
      nextEl: ".accompagnement-slider-Next",
      prevEl: ".accompagnement-slider-Prev",
    },
    pagination: {
      el: ".accompagnement-pagination",
      clickable: true,
    },
  });
});

jQuery(document).ready(function ($) {
  var menuTimer;

  // Prevent default click toggle
  $(".mega-menu > summary").on("click", function (e) {
    e.preventDefault();
  });

  $(".mega-menu").on("mouseenter", function () {
    clearTimeout(menuTimer); // stop any pending close
    $(this).attr("open", true); // open immediately
  });

  $(".mega-menu").on("mouseleave", function () {
    var $menu = $(this);
    menuTimer = setTimeout(function () {
      $menu.removeAttr("open"); // close after small delay
    }, 200); // delay in ms (adjust if needed)
  });

  var hoverTimer;

  // Prevent default click behavior inside header-menu
  $("header-menu details > summary").on("click", function (e) {
    e.preventDefault();
  });

  // Handle hover open/close
  $("header-menu details").on("mouseenter", function () {
    clearTimeout(hoverTimer);
    $(this).attr("open", true);
  });

  $("header-menu details").on("mouseleave", function () {
    var $this = $(this);
    hoverTimer = setTimeout(function () {
      $this.removeAttr("open");
    }, 200); // adjust delay as needed
  });
});

document.addEventListener("DOMContentLoaded", function () {
  // Target all summary elements that have an <a> inside
  document.querySelectorAll("summary a").forEach(function (link) {
    link.addEventListener("click", function (e) {
      e.stopPropagation(); // Prevent summary toggle
      // Optional: allow normal navigation (you could also use location.href if needed)
    });
  });
});



document.addEventListener("DOMContentLoaded", function () {
  // Custom quantity container
  const customQuantity = document.querySelector("quantity-input.cart-quantity");
  if (!customQuantity) {
    console.log("❌ Custom quantity box not found");
    return;
  }

  const customQtyInput = customQuantity.querySelector(".quantity__input");
  const plusBtn = customQuantity.querySelector('button[name="plus"]');
  const minusBtn = customQuantity.querySelector('button[name="minus"]');

  // Main quantity container inside .price-per-item__container
  const mainQuantityContainer = document.querySelector(
    ".price-per-item__container quantity-input.quantity"
  );
  if (!mainQuantityContainer) {
    console.log(
      "❌ Main quantity box not found inside .price-per-item__container"
    );
    return;
  }

  const mainQtyInput = mainQuantityContainer.querySelector(".quantity__input");
  const mainPlusBtn = mainQuantityContainer.querySelector(
    'button[name="plus"]'
  );
  const mainMinusBtn = mainQuantityContainer.querySelector(
    'button[name="minus"]'
  );

  console.log("✅ All selectors found successfully");

  // 1️⃣ Direct typing: update main input value and trigger change
  customQtyInput.addEventListener("input", function () {
    let val = parseInt(this.value);
    if (isNaN(val) || val < 1) val = 1;
    this.value = val;

    mainQtyInput.value = val;
    mainQtyInput.dispatchEvent(new Event("change", { bubbles: true }));
  });

  // 2️⃣ Custom plus click: trigger main plus click
  plusBtn.addEventListener("click", function () {
    console.log("Custom PLUS clicked → triggering main PLUS");
    mainPlusBtn.click();
  });

  // 3️⃣ Custom minus click: trigger main minus click
  minusBtn.addEventListener("click", function () {
    console.log("Custom MINUS clicked → triggering main MINUS");
    mainMinusBtn.click();
  });
});




function setDeliveryDate(forceUpdate = false) {
  const cutoffHour = 13;
  const deliveryDays = ["Dimanche", "Lundi", "Mardi", "Mercredi", "Jeudi", "Vendredi", "Samedi"];
  const monthNames = ["Janvier", "Février", "Mars", "Avril", "Mai", "Juin", "Juillet", "Août", "Septembre", "Octobre", "Novembre", "Décembre"];

  const now = new Date();
  const day = now.getDay();
  const hour = now.getHours();

  let deliveryDate = new Date();

  const addDays = (days) => deliveryDate.setDate(deliveryDate.getDate() + days);

  if (day === 5) {
    addDays(3);
  } else if (day === 6 || day === 0) {
    addDays(2);
  } else {
    if (hour < cutoffHour) {
      addDays(1);
    } else {
      addDays(day === 4 ? 2 : 2);
    }
  }

  const deliveryDayName = deliveryDays[deliveryDate.getDay()];
  const deliveryDateNumber = ("0" + deliveryDate.getDate()).slice(-2);
  const deliveryMonthName = monthNames[deliveryDate.getMonth()];
  const deliveryText = `${deliveryDayName} ${deliveryDateNumber} ${deliveryMonthName}`;

  document.querySelectorAll(".deliverydatebox span").forEach((span) => {
    if (forceUpdate || !span.textContent.trim()) {
      span.textContent = deliveryText;
    }
  });
}

function setupCartDrawerHook() {
  const drawerSelector = 'cart-drawer, #CartDrawer, .cart-drawer';
  let lastHTML = "";
  let retry = 0;

  const pollDOM = setInterval(() => {
    const drawer = document.querySelector(drawerSelector);
    if (drawer) {
      const htmlNow = drawer.innerHTML;
      if (htmlNow !== lastHTML) {
        lastHTML = htmlNow;
        setDeliveryDate(true);
      }
    }
    retry++;
    if (retry > 60) clearInterval(pollDOM); // stop after 30 sec
  }, 500);
}

document.addEventListener("DOMContentLoaded", function () {
  setDeliveryDate(true);

  let tries = 0;
  const safeRetry = setInterval(() => {
    setDeliveryDate(true);
    tries++;
    if (tries > 20) clearInterval(safeRetry);
  }, 500);

  setupCartDrawerHook();
});






